import { t } from "i18next";
import React from "react";

const FloatingFormActions = ({
  showFloatingButtons = false,
  leftPosition = false,
  onCancel,
  onSubmit,
  isSubmitting = false,
  cancelText = "Annuler",
  submitText = "Confirmer les changements",
  loadingText = "Sauvegarde...",
  disabled = false,
  className = "",
}) => {
  return (
    <div
      className={`form-actions ${className} ${
        true ? "floating show" : "inline"
      }`}
      style={{
        position: true ? "fixed" : "relative",
        bottom: true ? "0px" : "auto",
        left: true ? (leftPosition ? "8.3vh" : "28.3vh") : "auto",
        right: true ? "2vh" : "auto",
        backgroundColor: "#fff",
        padding: "12px 20px",
        marginTop: !true ? "20px" : "0",
        boxShadow: true ? "0 -2px 25px rgba(0,0,0,0.2)" : "none",
        zIndex: 10000,
        transform: true
          ? "translateY(0) scale(1)"
          : "translateY(20px) scale(0.95)",
        opacity: true ? 1 : 0.8,
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        animation: true ? "slideUpIn 0.4s ease-out forwards" : "none",
      }}
    >
      {/* Ligne gradient avec animation */}
      <div
        className="gradient-border-top"
        style={{
          position: "absolute",
          top: 0,
          left: "15%",
          right: "15%",
          height: "2px",
          background: true
            ? "linear-gradient(90deg, transparent 0%, #555B21 50%, transparent 100%)"
            : "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
          borderRadius: "1px",
          transition: "all 0.3s ease-in-out",
          opacity: true ? 1 : 0.7,
        }}
      />

      <div className="d-flex justify-content-center align-items-center gap-3">
        {/* Bouton Soumettre */}
        <button
          type="submit"
          className="btn btn-sm btn-primary"
          onClick={onSubmit}
          disabled={isSubmitting || disabled}
          style={{
            backgroundColor: "#555B21",
            borderColor: "#555B21",
            minWidth: "180px",
            fontSize: "0.85rem",
          }}
        >
          {isSubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {loadingText}
            </>
          ) : (
            <>
              <i className="bx bx-send me-1"></i>
              {submitText}
            </>
          )}
        </button>{" "}
        {/* Bouton Annuler */}
        <button
          type="button"
          className="btn btn-sm btn-soft-secondary"
          onClick={onCancel}
          disabled={isSubmitting}
          style={{
            minWidth: "100px",
            fontSize: "0.85rem",
          }}
        >
          <i className="bx bx-arrow-back me-1"></i>
          {cancelText}
        </button>
      </div>
    </div>
  );
};

export default FloatingFormActions;
